import { render, staticRenderFns } from "./AccountCertificateForm.vue?vue&type=template&id=0007809a&scoped=true&"
import script from "./AccountCertificateForm.vue?vue&type=script&lang=ts&"
export * from "./AccountCertificateForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCertificateForm.vue?vue&type=style&index=0&id=0007809a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007809a",
  null
  
)

export default component.exports